// extracted by mini-css-extract-plugin
export default {"gallery":"cards_gallery__Tjfpx","galleryContainer":"cards_galleryContainer__oOtyB","galleryHeading":"cards_galleryHeading__oXSA-","cardsContainer":"cards_cardsContainer__JEBFE"};